import { render, staticRenderFns } from "./SideMenuTooltip.vue?vue&type=template&id=72ac9547"
import script from "./SideMenuTooltip.vue?vue&type=script&lang=js"
export * from "./SideMenuTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports